module.exports = __webpack_public_path__ + "img/icons8-detective-128.3dd3a4aa.png";